import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const GOLD = "#e7b53a";
const GOLD_HI = "#f7d877";

function rockUnit(cx: number, cy: number, cz: number, s: number, c: string): Part[] {
  return [{ geometry: new THREE.IcosahedronGeometry(s, 0), color: c, position: [cx, cy, cz], scale: [1, 0.8, 0.92] as const }];
}

export const goldNugget = defineModel({
  id: "gold-nugget",
  batchId: "characters",
  name: "Gold nugget",
  tags: ["good", "cargo", "precious"],
  fits: ["carry"],
  summary: "A handful of gold nuggets -- a carriable good for an avatar's carry socket.",
  description:
    "Three gold nuggets at held scale, ported from age-of-mcp's goods (`gold`). " +
    "Mount it in a player's or worker's `carry` socket to show the figure " +
    "hauling gold.",
  author: "age-of-mcp",
  footprint: 0.06,
  parts: (): Part[] => [
    ...rockUnit(0, 0.045, 0.01, 0.055, GOLD),
    { geometry: new THREE.IcosahedronGeometry(0.055 * 0.5, 0), color: GOLD_HI, position: [0 + 0.055 * 0.3, 0.045 + 0.055 * 0.2, 0.01 - 0.055 * 0.2] },
    ...rockUnit(0.04, 0.03, 0.025, 0.035, GOLD_HI),
    ...rockUnit(-0.04, 0.03, -0.01, 0.03, GOLD),
  ],
  animations: [],
});
